
<template>
      <section class="page-section nav-section">
  
      <div class="container">
          
        <div class="article-nav">
          
          <div class="navs">
            <div
              v-for="(strategy, index) in strategies.strats"
              :key="`strategies_navs_${index}`"
            >
              <h2
                v-if="index !== strategies.selected"
                @click="() => selectStrategy(index)"
              >
                {{ strategy.shortHeader }}
              </h2>
              <h2 v-if="index === strategies.selected" class="active">
                {{ strategy.shortHeader }}
              </h2>
            </div>
          </div>
          <div class="selects">
            <form>
              <select v-model="strategies.selected">
                <option
                  v-for="(strategy, index) in strategies.strats"
                  :key="`strategies_option_${index}`"
                  :value="index"
                  
                >
                
                  {{ strategy.header }}
                </option>
              </select>
            </form>
          </div>
          <hr style="margin-bottom: 4rem" />

          <div class="nav-content">
            <div class="row">
                    <div class="card-space boxes">
                        
                        <div class="card three"
                            v-for="(policy, index) in strategies.strats[
                                strategies.selected
                            ].options"
                            :key="`strategies_text_${index}`"
                            >                                   
                        
                            <h6><img :src="require(`@/assets/images/Belfast/HorizontalTabIcons/${policy.image}.png`)" class="imgSmallIcon" style="width:45px;">{{policy.title}}</h6>
                    
                            <p>{{ policy.text }}</p>
                            </div>
                    </div>
            </div>
              
            </div>

          </div>
        </div>
     
    </section>
</template>
<script>

export default {
  name: "horizontal-tab",
   components: {
    
  },
  data() {
    return {
      
       strategies: {
        selected: 0,
        strats: [
          {
              image:'Branding-Marketing',
            shortHeader: "Service",
            header: "BRT2 will integrate with other planning processes including land use development, environmental enhancement, education and health care. Key features of the service operations will include:",
            options:[
                {  
                     title:'Operational Plans and Integration',
                     image:'Branding-Marketing',
                    text:"Service to operate between 05:30 and 23:30 on weekdays, 07:00 to 23:30 on Saturdays and 07:00 to 22:00 on Sundays"
                },
                {  
                     title:'Operational Plans and Integration',
                    image:'Branding-Marketing',
                    text:"Services operating at intervals of 10 -20 minutes"
                },
                {  
                     title:'Operational Plans and Integration',
                    image:'Branding-Marketing',
                    text:"Halts to be provided at a target distance of 400m"
                },
                {  
                     title:'Operational Plans and Integration',
                    image:'Branding-Marketing',
                    text:"Existing public transport services to provide either feeder or residual services"
                },
                {  
                     title:'Operational Plans and Integration',
                    image:'Branding-Marketing',
                    text:"Enforcement strategy to ensure no obstruction to the running ways (bus lanes)"
                },
                {  
                     title:'Operational Plans and Integration',
                    image:'Branding-Marketing',
                    text:" Punctuality and reliability to be monitored with targets of 99% and 95% respectively"
                },
            ]
            
            
          },
        
         {
            shortHeader: "Vehicles",
            header: "The existing Glider vehicles have delivered a step change in the quality of public transport for Belfast. They provide a high-quality environment for passengers, provides access for all, offers comfort, space and security accompanied with modern on-board travel information. BRT2 vehicles will build upon this quality and provide:",
            options:[
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"On-board areas for wheelchairs and pushchairs/ buggies."
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"Multiple double-width doors for boarding and alighting."
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"High levels of passenger comfort with low density seating and good legroom"
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"Engines to utilise the latest technologies and be low noise, low vibration and low or zero emission."
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"Multiple ‘infotainment’ screens visible with real-time information, visual and audible next halt and destination announcements."
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"On board CCTV to be provided for passenger safety and security."
                },
                {  
                     title:'Glider Vehicles',
                    image:'Vehicles',
                    text:"High standards of maintenance and cleanliness and interior panelling."
                }
            ]
            
            
          },
           {
            shortHeader: "Transport",
            header: "BRT2 will build upon the success of the Glider in East and West Belfast and will reflect the opportunities brought by new and emerging technologies. Recommended features for the BRT2 ITS include",
            options:[
                {  
                     title:'Intelligent Transport Systems and Real Time Information',
                    image:'IntelligentTS',
                    text:"All BRT2 vehicles to be fitted with an Automatic Vehicle Location (AVL) system used for real-time passenger information, operation of BRT2 priority at signal-controlled junctions and fleet operation and management"
                },
                {  
                     title:'Intelligent Transport Systems and Real Time Information',
                    image:'IntelligentTS',
                    text:"Real-Time Passenger Information (RTPI) to be provided on-board, at all halts, and through internet and mobile ‘phone services."
                },
                {  
                     title:'Intelligent Transport Systems and Real Time Information',
                    image:'IntelligentTS',
                    text:"Display signs supported by audio announcements to assist visually impaired users"
                },
                {  
                     title:'Intelligent Transport Systems and Real Time Information',
                    image:'IntelligentTS',
                    text:"The driver to have access to a 2-way radio system to allow calls to be made in an emergency"
                },
                
               
            ]
            
            
          },
           {
            shortHeader: "Ways",
            header: "The running ways consist primarily of dedicated bus lanes, priority at major junctions and elements of mixed traffic roads where enhanced priority is not feasible or practical. The running ways have established the philosophy that BRT measures will lead to reduced road capacity for general traffic and may lead to increased delays on non-public transport modes.", 
            options:[
                {  
                     title:'Running Ways',
                    image:'Runningways',
                    text:"The introduction of Glider in East and West Belfast has demonstrated that increased delays to general traffic are, in effect, accepted as part of the “trade off” of providing an enhanced public transport system. Retaining this approach will be fundamental to the successful operation of BRT2 services to ensure that it delivers rapid and reliable journeys." 
                }
               
            ]
            
            
          },
           {
            shortHeader: "Fares",
            header: "Consistent with the Glider operations in East and West Belfast, tickets for BRT2 will be purchased prior to boarding, so as to minimise waiting times at halts. Key features include:",
            options:[
                {  
                     title:'Fares & Fare Collection',
                    image:'Fares-Collections',
                    text:"A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments."
                },
                {  
                     title:'Fares & Fare Collection',
                    image:'Fares-Collections',
                    text:"Fares aligned with those charged by Translink on local bus services to enable seamless interchange with no additional cost incurred for transferring between services"
                },
                {  
                     title:'Fares & Fare Collection',
                    image:'Fares-Collections',
                    text:"Concessionary fares in operation in line with current Dfl policy with reimbursement consistent with that offered to Translink."
                },
                {  
                     title:'Fares & Fare Collection',
                    image:'Fares-Collections',
                    text:"Off-board ticketing facilities to minimise halt waiting times supported by on-vehicle ticket inspection."
                },
                {  
                     title:'Fares & Fare Collection',
                    image:'Fares-Collections',
                    text:"Payment systems and tariffs to encourage cashless payment."
                }
            ]
            
            
          },
           {
            shortHeader: "Halts",
            header: "In East and West Belfast, the Glider halts have been a key part of the system image offering a distinct and high quality passenger waiting environment that separates them from non BRT bus stops. Building on this success, the recommended requirements for the BRT2 halts and interchanges are:",
            options:[
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:"High quality branded halts with paving, illuminated shelters, seating, off-board ticketing machines and validators, realtime passenger information & CCTV."
                },
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:" Safe, secure and signed pedestrian routes to be provided to/from halts with pedestrian crossings providing access to halts."
                },
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:"20m of bus access kerbs provided at each halt to allow boarding at each door."
                },
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:"Halt design to be consistent and minimise step height onto vehicles"
                },
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:"Interchange halts to be provided in the City Centre and locations of interchange with other public transport services"
                },
                {  
                     title:'Halts & Interchanges',
                    image:'Halts-Interchanges',
                    text:"Interchange and/or Park & Ride facilities to be located at key locations with high quality and secure parking facilities for vehicles and cycles."
                },
            ]
            
            
          }
          
        ],
      },
    }
  },
    methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    },
   
   
  },
 

 
};
</script>

